import { Text, Switch } from "@flat-ui";
import { TableCell, TableRow } from "@mui/material";
import { FeatureToggle } from "@components/dev-features-dialog/features";

interface FeaturesTableRowProps {
  /** The feature item to display in the row */
  item: FeatureToggle;
}

/**
 * @returns A row of the DevFeatures table that allows to modify the feature state
 */
export function DevFeaturesTableRow({ item }: FeaturesTableRowProps): JSX.Element {
  return (
    <TableRow key={item.label}>
      <TableCell sx={{ p: 1.5 }}>
        <Text variant="heading12">{item.label}</Text>
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Text variant="helpText">{item.description}</Text>
      </TableCell>
      <TableCell sx={{ p: 1, textAlign: "center" }}>
        <Switch
          checked={item.isEnabled}
          onToggle={() => item.onToggle(!item.isEnabled)}
          label=""
          // Requires overflow hidden because it seems when toggled it grows a bit and causes layout shift
          sx={{ justifySelf: "end", overflow: "hidden" }}
        />
      </TableCell>
    </TableRow>
  );
}
